var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17264",
    "data-name": "Group 17264",
    transform: "translate(19016 16116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(-19016 -16116)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11",
    transform: "translate(-19017.346 -16117.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8344",
    "data-name": "Path 8344",
    d: "M40.4,40.652a1.356,1.356,0,0,1,.333.483l1.23-1.055a1.14,1.14,0,0,0-1.07.177Z",
    transform: "translate(-27.015 -26.949)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8345",
    "data-name": "Path 8345",
    d: "M3.346,43.892l1.923,4.087,1.419-.811L4.75,43.291Z",
    transform: "translate(0 -29.336)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8346",
    "data-name": "Path 8346",
    d: "M37,40.284a1.338,1.338,0,0,1,.422.074l.406-.325a.928.928,0,0,0-.712.163Z",
    transform: "translate(-24.536 -26.949)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8347",
    "data-name": "Path 8347",
    d: "M22.457,40a.585.585,0,0,0-.259.061l-.332.166-1.871,1.6a.271.271,0,0,1-.176.065H17.109v-.542H19.5a.814.814,0,0,0-.766-.542H16.567a.271.271,0,0,1-.121-.027L16,40.561a2.746,2.746,0,0,0-2.75.171l-.866.577-.029.017-.406.2,1.082,2.165a4.281,4.281,0,0,1,2.9-.382l.493.11a4.17,4.17,0,0,0,3.308-.664l3.29-2.323-.014-.041A.578.578,0,0,0,22.457,40Z",
    transform: "translate(-6.271 -26.936)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8348",
    "data-name": "Path 8348",
    d: "M19.7,5.478,12.433,3.054,5.162,5.478,12.433,7.9Zm-7.813,0a.542.542,0,1,1,.542.542.542.542,0,0,1-.542-.542Z",
    transform: "translate(-1.324 0)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8349",
    "data-name": "Path 8349",
    d: "M24.212,24.9A8.367,8.367,0,0,1,15,24.9v.7a7.857,7.857,0,0,0,9.212,0Z",
    transform: "translate(-8.497 -15.927)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8350",
    "data-name": "Path 8350",
    d: "M24.212,17.388l-4.52,1.507a.271.271,0,0,1-.171,0L15,17.388v1.378a7.834,7.834,0,0,0,9.212,0Z",
    transform: "translate(-8.497 -10.45)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8351",
    "data-name": "Path 8351",
    d: "M55.084,16.992v-2.6l-.542.18v2.424L54,18.347v.542h1.626v-.542Z",
    transform: "translate(-36.93 -8.263)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialization);
export default __webpack_public_path__ + "static/media/Specialization.1c60150f192d4bcc8ecf785a55df1837.svg";
export { ForwardRef as ReactComponent };